// Instagram blok na detailu produktu — obsah je jeden společný v HTML kódech šablony
// (<template id="myig-template">), tady se jen vloží pod obsah detailu. Ručně vložený
// blok .other-ig v popisu produktu (staré zástupné fotky) nahradí.
// Běží před product-detail.js (abecední pořadí v bundlu) — ten pak pod blok přesune
// související produkty, stejně jako dřív pod .other-ig.
$(document).ready(function () {
    if (getShoptetDataLayer("pageType") !== "productDetail") return;

    const template = document.getElementById("myig-template");
    if (!template || !template.content || !$(".content-wrapper-in").length) return;

    const source = template.content.querySelector(".myig-block");
    if (!source || !source.querySelector(".myig-item")) return;

    const $block = $(document.importNode(source, true));

    $(".other-ig").remove();
    $block.insertAfter(".content-wrapper-in");
});
